import { useState } from "react";
import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerFooter,
  DrawerClose,
} from "@/components/ui/drawer";

interface Props {
  tripType: string | null | undefined;
  className?: string;
}

/**
 * Enabled secondary button that, when tapped, explains why manual departure
 * isn't available for this trip and directs the driver to contact dispatch.
 * Used in place of the disabled amber "Ready to Depart" CTA on NVO/SVO/CI
 * (and unknown-trip-type) legs in the Driver view.
 */
export function ManualDepartureSheet({ tripType, className }: Props) {
  const [open, setOpen] = useState(false);
  const label = tripType
    ? `Manual departure not available for ${tripType} trips`
    : "Manual departure not available";
  const body = tripType
    ? `This is an ${tripType} trip. If you believe this should depart as a Manual trip, contact your dispatcher.`
    : "This trip is not marked as Manual. If you believe this should depart as a Manual trip, contact your dispatcher.";

  return (
    <>
      <Button
        type="button"
        variant="outline"
        onClick={() => setOpen(true)}
        className={className ?? "w-full"}
      >
        <Info className="h-5 w-5 mr-2" />
        {label}
      </Button>
      <Drawer open={open} onOpenChange={setOpen}>
        <DrawerContent>
          <DrawerHeader className="text-left">
            <DrawerTitle>Manual departure not available</DrawerTitle>
          </DrawerHeader>
          <div className="px-4 pb-2 text-sm text-muted-foreground">
            {body}
          </div>
          <DrawerFooter>
            <DrawerClose asChild>
              <Button variant="outline">Close</Button>
            </DrawerClose>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}